var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenGradientBgClipped480X600(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480 522.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:url(#c);}.e{fill:none;}.f{fill:#bfd9c2;}.f,.g{fill-rule:evenodd;}.g{fill:#edfff5;}.h{clip-path:url(#b);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 480,
    height: 522.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 240.8,
    y1: 602,
    x2: 240.8,
    y2: 2,
    gradientTransform: "translate(0 602) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "teal"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "teal",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "teal",
    stopOpacity: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.8,
    width: 480,
    height: 600,
    rx: 90,
    ry: 90
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M480,184.5c0,.2-.2,.4-.4,.4-108,0-361.2,17.5-479.2,33.7-.2,0-.4-.1-.4-.3,0-.2,.2-.4,.4-.4,118-16.2,371.2-33.8,479.3-33.8s.4,.2,.3,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M237.3,451.2c-90,30.9-178.3,66.1-233,89.1-.2,0-.4,0-.5-.2-.1-.2,0-.4,.1-.5,54.6-23.1,143-58.2,233-89.2,90-30.9,181.6-57.7,242.6-63.9,.2,0,.4,.1,.5,.3,0,.2,0,.4-.3,.4-60.9,6.2-152.4,32.9-242.4,63.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M239.6,105.3C148.7,118.9,57.8,136.2,.5,148.1c-.2,0-.4,0-.4-.3,0-.2,0-.4,.3-.4,57.3-11.9,148.3-29.2,239.2-42.8,90.9-13.6,181.7-23.6,238.6-21,.2,0,.4,.2,.4,.4,0,.2-.2,.4-.4,.4-56.9-2.7-147.6,7.3-238.5,20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M243.1,116C152.1,120.2,60,127.9,.4,133.9c-.2,0-.4-.1-.4-.3,0-.2,.2-.4,.4-.4,59.7-5.9,151.8-13.7,242.8-17.9,91-4.2,181-4.8,236.5,3.6,.2,0,.3,.2,.3,.4,0,.2-.3,.3-.5,.3-55.4-8.4-145.3-7.8-236.3-3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M247.4,78.6c-90.8-4.7-183.7-5.9-244.1-6.2-.2,0-.4-.2-.3-.3,0-.2,.3-.3,.5-.3,60.4,.3,153.3,1.6,244.2,6.2,90.8,4.7,179.7,12.8,232.2,26.8,.2,0,.3,.2,.2,.4-.1,.2-.4,.3-.6,.2-52.4-14-141.2-22.1-232-26.8Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenGradientBgClipped480X600);
export default __webpack_public_path__ + "static/media/green-gradient-bg-clipped-480x600.4aec010bbe1995396db14ab6de712795.svg";
export { ForwardRef as ReactComponent };